export type AgencyStatusTone = 'success' | 'warning' | 'muted'

export function getAgencyStatusTone(status: string): AgencyStatusTone {
  const normalized = status.trim().toLowerCase()

  if (normalized === 'active') {
    return 'success'
  }

  if (normalized === 'suspended' || normalized === 'inactive') {
    return 'warning'
  }

  return 'muted'
}
